import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// ── Local image imports ──
import aboutImg               from '../assets/images/AboutTheOrthomed.png';
import geethImg               from '../assets/images/GeethaBhargavi.jpeg';
import sadhanImg              from '../assets/images/SadhanPalakuri.jpeg';
import wherescience           from '../assets/images/WhereScience.png';
import RegenerativePainMedicine from '../assets/images/RegenerativePainMedicine.png';
import SportsOrthopaedics     from '../assets/images/SportsOrthopaedics.png';
import SportsPhysiotherapy    from '../assets/images/SportsPhysiotherapy.png';

// ── Hero slide images — add these 3 files to src/assets/images/ ──
import HeroSlide1 from '../assets/images/HeroSlide1.png';
import HeroSlide2 from '../assets/images/HeroSlide2.png';
import HeroSlide3 from '../assets/images/HeroSlide3.png';

import './Home.css';

const HERO_IMAGES = [HeroSlide1, HeroSlide2, HeroSlide3];

export default function Home() {
  const [heroIdx, setHeroIdx] = useState(0);
  const [testi,   setTesti]   = useState(0);
  const [fadingOut, setFadingOut] = useState(false);

  /* ── Auto-slide every 4 s with fade transition ── */
  useEffect(() => {
    const t = setInterval(() => {
      setFadingOut(true);
      setTimeout(() => {
        setHeroIdx(i => (i + 1) % HERO_IMAGES.length);
        setFadingOut(false);
      }, 350);
    }, 4000);
    return () => clearInterval(t);
  }, []);

  const goToSlide = (i) => {
    if (i === heroIdx) return;
    setFadingOut(true);
    setTimeout(() => { setHeroIdx(i); setFadingOut(false); }, 350);
  };

  /* Testimonials auto-advance */
  useEffect(() => {
    const t = setInterval(() => setTesti(p => (p + 1) % 4), 5000);
    return () => clearInterval(t);
  }, []);

  const testimonials = [
    { name: 'Ramesh K.',  loc: 'Hyderabad, 52 yrs',    treat: 'PRP Therapy',       text: "After years of knee pain, Dr. Sadhan's PRP therapy gave me complete relief in just 6 weeks. I can now walk and climb stairs without any discomfort. The team at TheOrthomed is exceptional.", img: 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=80&q=80' },
    { name: 'Priya S.',   loc: 'Bengaluru, 38 yrs',    treat: 'Stem Cell Therapy',  text: "Dr. Geetha's stem cell treatment for my disc herniation was life-changing. I avoided surgery completely and resumed my active lifestyle within 8 weeks. Highly recommend!", img: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&q=80' },
    { name: 'Vikram T.',  loc: 'Hyderabad, Athlete',   treat: 'ACL Reconstruction', text: "Tore my ACL during a football match. The arthroscopic repair and physiotherapy at TheOrthomed had me back on the field in just 4 months. Incredible doctors and team.", img: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=80&q=80' },
    { name: 'Lakshmi R.', loc: 'Secunderabad, 61 yrs', treat: 'BMAC Therapy',       text: "I was told I needed knee replacement surgery. After BMAC therapy at TheOrthomed, my pain reduced by 90% and I never needed surgery. Best decision of my life.", img: 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=80&q=80' },
  ];
  const T = testimonials[testi];

  return (
    <div>

      {/* ══════════════════════════════════════
          HERO — original dark blue bg
          LEFT: original text  |  RIGHT: image slider
      ══════════════════════════════════════ */}
      <section className="hero">

        {/* Original background photo + dark overlay — unchanged */}
        <div className="hero-bg">
          <img src="https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=1400&q=80" alt="Medical care" />
          <div className="hero-overlay" />
        </div>

        {/* Two-column layout: text left, slider image right */}
        <div className="container hero-split">

          {/* ── LEFT: original text content ── */}
          <div className="hero-content">
            <div className="hero-badge">
              <span className="hero-dot" />
              Scar free <span className="hero-dot" /> Drug free <span className="hero-dot" /> Research Backed
            </div>
            <h1 className="hero-title">
              Relief Without Scar<br />
              <span className="accent">Results Without Medication.</span>
            </h1>
            <p className="hero-sub">
              Hyderabad's premier center for regenerative pain medicine, stem cell therapies,
              and sports orthopaedics — helping you recover without surgery.
            </p>
            <div className="hero-btns">
              <Link to="/contact" className="btn-blue">Book Appointment →</Link>
              <Link to="/treatments/pain-medicine" className="btn-ghost">Explore Treatments</Link>
            </div>
            <div className="hero-tags">
              <span>PRP Therapy</span>
              <span>Stem Cell</span>
              <span>Arthroscopy</span>
              <span>Spine Interventions</span>
              <span>Sports Rehab</span>
            </div>
          </div>

          {/* ── RIGHT: sliding patient image ── */}
          <div className="hero-slider-col">
            <div className="hero-slider-arc" />
            <img
              src={HERO_IMAGES[heroIdx]}
              alt={`Slide ${heroIdx + 1}`}
              className={`hero-slide-img ${fadingOut ? 'slide-out' : 'slide-in'}`}
            />
            {/* Dot indicators */}
            <div className="hero-slider-dots">
              {HERO_IMAGES.map((_, i) => (
                <button
                  key={i}
                  className={`hero-sdot ${i === heroIdx ? 'active' : ''}`}
                  onClick={() => goToSlide(i)}
                  aria-label={`Slide ${i + 1}`}
                />
              ))}
            </div>
          </div>

        </div>
      </section>

      {/* ── STATS ── */}
      <section className="stats-bar">
        <div className="container stats-row">
          <div className="stat"><div className="stat-val">5000+</div><div className="stat-lbl">Patients Treated</div></div>
          <div className="stat"><div className="stat-val">15+</div><div className="stat-lbl">Years Experience</div></div>
          <div className="stat"><div className="stat-val">98%</div><div className="stat-lbl">Success Rate</div></div>
          <div className="stat"><div className="stat-val">50+</div><div className="stat-lbl">Procedures</div></div>
        </div>
      </section>

      {/* ── ABOUT STRIP ── */}
      <section className="section">
        <div className="container about-grid">
          <div className="about-imgs">
            <div className="about-img-main"><img src={aboutImg} alt="About TheOrthomed" /></div>
            <div className="about-img-sm"><img src={wherescience} alt="Lab" /></div>
            <div className="about-float">
              <span style={{ fontSize: 22 }}>🧬</span>
              <div><div className="float-val">Regenerative</div><div className="float-sub">Medicine First</div></div>
            </div>
          </div>
          <div className="about-text">
            <div className="tag-line"><span>About TheOrthomed</span></div>
            <h2 className="sec-title">Where Science Meets<br /><span className="accent">Natural Healing</span></h2>
            <p style={{ fontSize: 15.5, color: '#475569', lineHeight: 1.8, marginBottom: 20 }}>
              TheOrthomed is Hyderabad's advanced center for regenerative orthopaedic medicine —
              combining sports orthopaedics, biological therapies, and precision pain management under one roof.
            </p>
            <p style={{ fontSize: 15.5, color: '#475569', lineHeight: 1.8, marginBottom: 28 }}>
              We believe most musculoskeletal conditions can be treated{' '}
              <strong style={{ color: '#0D4E9A' }}>without major surgery</strong>. Our approach
              uses the body's own healing mechanisms — stem cells, PRP, and BMAC — to regenerate damaged tissue at its source.
            </p>
            <div className="check-grid">
              {['Avoid unnecessary surgery','Faster recovery times','Evidence-based treatment','Fellowship-trained doctors','Integrated rehab & physio','Personalised care plans'].map(p => (
                <div key={p} className="check-item"><span className="check">✓</span>{p}</div>
              ))}
            </div>
            <Link to="/about" className="btn-blue" style={{ marginTop: 28, display: 'inline-flex' }}>Learn More →</Link>
          </div>
        </div>
      </section>

      {/* ── TREATMENTS ── */}
      <section className="section" style={{ background: '#F8FAFC' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 52 }}>
            <div className="tag-line" style={{ justifyContent: 'center' }}><span>Our Specialties</span></div>
            <h2 className="sec-title" style={{ textAlign: 'center' }}>Comprehensive Care <span className="accent">Under One Roof</span></h2>
            <p style={{ fontSize: 16, color: '#475569', maxWidth: 580, margin: '0 auto', lineHeight: 1.75 }}>From stem cell therapy to arthroscopic surgery and sports rehabilitation — covering the full spectrum.</p>
          </div>
          <div className="tx-grid">
            <Link to="/treatments/pain-medicine" className="tx-card">
              <div className="tx-img"><img src={RegenerativePainMedicine} alt="Pain Medicine" /><div className="tx-overlay" /><span className="tx-tag" style={{ background: '#0D4E9A22', color: '#0D4E9A' }}>Primary Focus</span></div>
              <div className="tx-body"><div className="tx-icon">🔬</div><h3>Regenerative Pain Medicine</h3><p>Advanced biological therapies — PRP, BMAC, stem cells — to eliminate chronic pain without surgery.</p><ul><li>PRP Therapy</li><li>BMAC Therapy</li><li>Stem Cell Therapy</li><li>Spine Interventions</li></ul><div className="tx-cta">Explore →</div></div>
            </Link>
            <Link to="/treatments/orthopaedics" className="tx-card">
              <div className="tx-img"><img src={SportsOrthopaedics} alt="Orthopaedics" /><div className="tx-overlay" /><span className="tx-tag" style={{ background: '#0F6E5622', color: '#0F6E56' }}>Sports Focused</span></div>
              <div className="tx-body"><div className="tx-icon">🦴</div><h3>Sports Orthopaedics</h3><p>Precision orthopaedic care for athletes — arthroscopy, joint restoration, and minimally invasive surgery.</p><ul><li>Arthroscopy</li><li>Knee Replacement</li><li>Ligament Repair</li><li>OrthoBiologics</li></ul><div className="tx-cta">Explore →</div></div>
            </Link>
            <Link to="/treatments/physiotherapy" className="tx-card">
              <div className="tx-img"><img src={SportsPhysiotherapy} alt="Physiotherapy" /><div className="tx-overlay" /><span className="tx-tag" style={{ background: '#7C3AED22', color: '#7C3AED' }}>Active Recovery</span></div>
              <div className="tx-body"><div className="tx-icon">💪</div><h3>Sports Physiotherapy</h3><p>Evidence-based rehabilitation and sports performance programs for injury recovery and prevention.</p><ul><li>Sports Physiotherapy</li><li>Sports Rehabilitation</li><li>Strength Training</li></ul><div className="tx-cta">Explore →</div></div>
            </Link>
          </div>
        </div>
      </section>

      {/* ── REGENERATIVE BANNER ── */}
      <section className="regen-section">
        <div className="regen-bg"><img src="https://images.unsplash.com/photo-1576086213369-97a306d36557?w=1400&q=80" alt="Stem cell" /><div className="regen-overlay" /></div>
        <div className="container regen-grid">
          <div>
            <div className="tag-line"><span style={{ color: '#00A8E8' }}>Regenerative Medicine</span></div>
            <h2 style={{ fontSize: 'clamp(28px,3vw,42px)', fontWeight: 800, color: '#fff', lineHeight: 1.2, marginBottom: 20 }}>Your Body Has the Power to Heal Itself</h2>
            <p style={{ fontSize: 15.5, color: 'rgba(255,255,255,0.78)', lineHeight: 1.8, marginBottom: 16 }}>Regenerative medicine uses biological therapies from your own body — PRP, BMAC, and stem cells — to repair damaged tissue and eliminate chronic pain without surgery.</p>
            <p style={{ fontSize: 15.5, color: 'rgba(255,255,255,0.78)', lineHeight: 1.8, marginBottom: 32 }}>Ideal for patients above 45 and athletes of all ages — our regenerative protocols are tailored to your unique condition and recovery goals.</p>
            <Link to="/treatments/pain-medicine" className="btn-blue">Explore Regenerative Treatments →</Link>
          </div>
          <div className="regen-cards">
            <div className="regen-card"><div className="rc-icon">🩸</div><div><div className="rc-title">PRP Therapy</div><div className="rc-desc">Concentrated growth factors from your blood to heal damaged joints and soft tissue.</div></div></div>
            <div className="regen-card"><div className="rc-icon">🦴</div><div><div className="rc-title">BMAC Therapy</div><div className="rc-desc">Bone marrow stem cells and growth factors applied directly to injury sites.</div></div></div>
            <div className="regen-card"><div className="rc-icon">🔬</div><div><div className="rc-title">Stem Cell Therapy</div><div className="rc-desc">Mesenchymal stem cells regenerate cartilage, tendons and connective tissue.</div></div></div>
            <div className="regen-card"><div className="rc-icon">🦋</div><div><div className="rc-title">Spine Interventions</div><div className="rc-desc">Minimally invasive procedures for disc and nerve pain without open surgery.</div></div></div>
          </div>
        </div>
      </section>

      {/* ── DOCTORS ── */}
      <section className="section">
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 52 }}>
            <div className="tag-line" style={{ justifyContent: 'center' }}><span>Our Specialists</span></div>
            <h2 className="sec-title" style={{ textAlign: 'center' }}>Expert Doctors, <span className="accent">Exceptional Care</span></h2>
          </div>
          <div className="doc-grid">
            <div className="doc-card">
              <div className="doc-header" style={{ background: 'linear-gradient(135deg,#1565C0,#00A8E8)' }}>
                <div className="doc-photo"><img src={sadhanImg} alt="Dr. Sadhan Palakuri" /></div>
                <div><h3 className="doc-name">Dr. Sadhan Palakuri</h3><p className="doc-qual">MBBS, MS.Ortho, FIAS, FIJR, FIPM</p></div>
              </div>
              <div className="doc-body">
                <div className="doc-role">● Consultant Sports Orthopaedics</div>
                <div className="doc-role">● Arthroscopy Knee &amp; Shoulder Specialist</div>
                <div className="doc-role">● Regenerative OrthoBiologist</div>
                <p className="doc-bio">Fellowship-trained sports orthopaedic surgeon combining arthroscopic precision with regenerative orthobiology for athletes.</p>
                <Link to="/doctors" className="doc-link">View Full Profile →</Link>
              </div>
            </div>
            <div className="doc-card">
              <div className="doc-header" style={{ background: 'linear-gradient(135deg,#0D4E9A,#00A8E8)' }}>
                <div className="doc-photo"><img src={geethImg} alt="Dr. Geetha Bhargavi" /></div>
                <div><h3 className="doc-name">Dr. Geetha Bhargavi</h3><p className="doc-qual">MBBS, MD.Anaesth, FIPM</p></div>
              </div>
              <div className="doc-body">
                <div className="doc-role">● Consultant Pain Physician</div>
                <div className="doc-role">● Interventional Spine Specialist</div>
                <div className="doc-role">● Regenerative Medicine Expert</div>
                <p className="doc-bio">Fellowship-trained pain physician specializing in PRP, BMAC, and stem cell therapies for chronic pain relief without surgery.</p>
                <Link to="/doctors" className="doc-link">View Full Profile →</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── WHY US ── */}
      <section className="section" style={{ background: '#F8FAFC' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 52 }}>
            <div className="tag-line" style={{ justifyContent: 'center' }}><span>Why Choose Us</span></div>
            <h2 className="sec-title" style={{ textAlign: 'center' }}>Focused Care. <span className="accent">Proven Results.</span></h2>
          </div>
          <div className="why-grid">
            <div className="why-card"><div className="why-icon">🧬</div><h3>Regenerative First</h3><p>We exhaust all biological options before considering surgery.</p></div>
            <div className="why-card"><div className="why-icon">🏆</div><h3>Fellowship Trained</h3><p>Both doctors hold international fellowships in their specialties.</p></div>
            <div className="why-card"><div className="why-icon">🎯</div><h3>Precision Diagnosis</h3><p>Advanced imaging to pinpoint the exact root cause of your pain.</p></div>
            <div className="why-card"><div className="why-icon">⚡</div><h3>Faster Recovery</h3><p>Most patients return to normal activity within weeks, not months.</p></div>
            <div className="why-card"><div className="why-icon">🤝</div><h3>Personalised Plans</h3><p>Every treatment plan is custom-built for your condition and goals.</p></div>
            <div className="why-card"><div className="why-icon">♻️</div><h3>Integrated Care</h3><p>Pain management, orthopaedics &amp; physio under one roof.</p></div>
          </div>
        </div>
      </section>

      {/* ── TESTIMONIALS ── */}
      <section className="testi-section">
        <div className="testi-bg"><img src="https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=1400&q=80" alt="" /><div className="testi-overlay" /></div>
        <div className="container testi-content">
          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <div className="tag-line" style={{ justifyContent: 'center' }}><span style={{ color: '#00A8E8' }}>Patient Stories</span></div>
            <h2 style={{ fontSize: 'clamp(28px,3vw,42px)', fontWeight: 800, color: '#fff', textAlign: 'center' }}>Real Recovery. <span style={{ color: '#00A8E8' }}>Real Lives.</span></h2>
          </div>
          <div className="testi-box">
            <div className="testi-quote">"</div>
            <p className="testi-text">{T.text}</p>
            <div className="testi-stars">★★★★★</div>
            <div className="testi-author">
              <img src={T.img} alt={T.name} className="testi-avatar" />
              <div><div className="testi-name">{T.name}</div><div className="testi-loc">{T.loc}</div><div className="testi-treat">{T.treat}</div></div>
            </div>
          </div>
          <div className="testi-dots">
            {[0,1,2,3].map(i => (<button key={i} className={`tdot ${i===testi?'active':''}`} onClick={()=>setTesti(i)} />))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="cta-section">
        <div className="cta-bg" style={{ backgroundImage: "url(https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=1400&q=80)" }} />
        <div className="cta-overlay" />
        <div className="container cta-content">
          <div className="tag-line" style={{ justifyContent: 'center' }}><span>Get Started Today</span></div>
          <h2 style={{ fontSize: 'clamp(28px,3vw,44px)', fontWeight: 800, color: '#fff', textAlign: 'center', marginBottom: 16 }}>Take the First Step Towards<br /><span style={{ color: '#00A8E8' }}>Pain-Free Living</span></h2>
          <p style={{ fontSize: 16, color: 'rgba(255,255,255,0.78)', textAlign: 'center', maxWidth: 520, margin: '0 auto 36px' }}>Book a consultation with our specialists. We'll assess your condition and design a personalised treatment plan.</p>
          <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/contact" className="btn-blue" style={{ fontSize: 16, padding: '14px 32px' }}>Book Appointment →</Link>
            <Link to="/treatments/pain-medicine" style={{ fontSize: 16, padding: '14px 32px', borderRadius: 8, background: '#fff', color: '#0D4E9A', fontWeight: 700, textDecoration: 'none', display: 'inline-flex', alignItems: 'center' }}>View Treatments</Link>
          </div>
        </div>
      </section>

    </div>
  );
}
